import React, { useState,useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import FamilyForm from "../../components/UserProfile/FamilyForm";
import FinancialForm from "../../components/UserProfile/FinancialForm";
import { toast } from "../../components/Common/Toast";
import axios from "axios";
import config from "../../config";
import { setUser } from "../../features/user/userSlice";

const FamilyDetailsForm = () => {
  const [familyDetails, setFamilyDetails] = useState({
    mother: "", father: "", sisters: "", brothers: ""
  });
  const [financialStatus, setFinancialStatus] = useState("");
  const [showFinancialForm, setShowFinancialForm] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const { userInfo, token } = useSelector(state => state.user);
  const dispatch = useDispatch()

    useEffect(() => {
    const otherData = JSON.parse(sessionStorage.getItem("otherData"));
    if (otherData?.familyDetails) {
      setFamilyDetails(otherData?.familyDetails)
    }
    if (otherData?.financialStatus) {
      setFinancialStatus(otherData?.financialStatus)
    }
  }, []);

  const handleFamilyChange = (e) => {
    const { name, value } = e.target;
    setFamilyDetails(prev => ({ ...prev, [name]: value }));
  };

  const handleFinancialChange = (e) => setFinancialStatus(e.target.value);

  const handleFamilySubmit = (e) => {
    e.preventDefault();
    setShowFinancialForm(true);
  };

  const handleFinancialSubmit = async (formData) => {
    try {
      setIsLoading(true);
      setError(null);
      
      // Get data from sessionStorage
      const otherData = JSON.parse(sessionStorage.getItem("otherData") || '{}');
      
      // Combine form data with preferences
      const completeData = {
        ...otherData,
        familyDetails, financialStatus
      };
      console.log("completeData",completeData);
      // Make API call
      const response = await axios.post(
        `${config.baseURL}/api/profile/additional-info`,
        completeData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
  
      console.log("Data saved successfully:", response.data);
      
      if (response.data.success) {
        toast.success("Data saved successfully!");
          let updatedUser = {
            ...userInfo,
            verificationData:  otherData.verificationData,
            hobbies:  otherData.hobbies,
            financial_status:  financialStatus,
            family_details:  familyDetails,
          };
          console.log("Family Detail Form updatedUser", updatedUser)
          dispatch(setUser({
            userInfo: updatedUser,
            token: token,
          }));
        if(response.data.special){
          navigate("/dashboard");
          sessionStorage.removeItem("otherData")
        }
      } else {
        throw new Error(response.data.message || "Failed to save data");
      }
    } catch (err) {
      console.error("Submission error:", err);
      const errorMessage = err.response?.data?.message || err.message || "Failed to save data. Please try again.";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="verfiy-profile">
        <div className="verfiy-profile-new">
          {!showFinancialForm ? (
            <FamilyForm 
              familyDetails={familyDetails}
              handleFamilyChange={handleFamilyChange}
              handleFamilySubmit={handleFamilySubmit}
            />
          ) : (
            <FinancialForm 
              financialStatus={financialStatus}
              handleFinancialChange={handleFinancialChange}
              handleFinancialSubmit={handleFinancialSubmit}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default FamilyDetailsForm;